import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AuthStore, UrlUtils } from '@vectord/utils';

import { BASE_SCM_SERVICE_TAG_TYPES } from 'data/baseScmServiceTagTypes';
import normalizeResponse from 'utils/normalizeResponse';

/**
 *  This service will be used for all v3/scm apis
 */

const baseScmQuery = fetchBaseQuery({
  baseUrl: UrlUtils.join(process.env.REACT_APP_API_BASE, 'v3/scm/'),
  prepareHeaders: (headers) => {
    const { jwt } = AuthStore.get();
    if (jwt) {
      headers.set('X-User-Token', jwt);
    }
    return headers;
  },
});

const baseScmService = createApi({
  reducerPath: 'scmApi',
  tagTypes: BASE_SCM_SERVICE_TAG_TYPES,
  baseQuery: async function (...args) {
    const response = await baseScmQuery(...args);
    if (response.meta.response.ok && response.data?.data) {
      return {
        ...response,
        data: normalizeResponse(response.data),
      };
    } else {
      return response;
    }
  },
  endpoints: () => ({}),
});

export default baseScmService;
